import styled from 'styled-components';

export default styled.img`
    height: 100%;
    aspect-ratio: 1;
    border-radius: 100%;
    background: var(--button-bg);
`;
